import { Grid, Card, CardContent, Typography } from '@mui/material';

export default function ResumenCards({
  ventas,
  compras,
  gastos,
  utilidad
}) {
  const cards = [
    { label: 'Ventas', value: ventas, color: '#2e7d32' },
    { label: 'Compras', value: compras, color: '#1565c0' },
    { label: 'Gastos', value: gastos, color: '#c62828' },
    { label: 'Resultado', value: utilidad, color: utilidad >= 0 ? '#2e7d32' : '#c62828' },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map(c => (
        <Grid item xs={6} md={3} key={c.label}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">{c.label}</Typography>
              <Typography
                variant="h5"
                sx={{ color: c.color, fontWeight: 'bold' }}
              >
                {c.value.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
